const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/artists/$id.general.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindAllOrganizationUnitsSuspenseQueryOptions, getFindArtistSuspenseQueryOptions } from '@api';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/artists/$id/general')({
  loader: async ({
    context: {
      queryClient
    },
    params
  }) => {
    queryClient.ensureQueryData(getFindArtistSuspenseQueryOptions(params.id));
    queryClient.ensureQueryData(getFindAllOrganizationUnitsSuspenseQueryOptions());
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});